import { Handle, Position } from 'reactflow';


import './TimeLine.css';

import $ from 'jquery'; 


function TimelineNode({ id, data }) {

  // const showCard = (card_el) => {

  //   if ($("#"+card_el).hasClass("show-node-card-content")){
  //     $("#"+card_el).removeClass("show-node-card-content");
  //   }

  //   else {
  //     $("#"+card_el).addClass("show-node-card-content");
  //   }

  // };


  const compareNode = (el_id, id) => {

    const el = $('#'+el_id+id)[0];
    
    // remove node from compare list
    if (el.classList.contains('node-to-compare')){
      el.classList.remove('node-to-compare');
    }

    // add note to compare list
    else {
      el.classList.add('node-to-compare');
    }

  }

  return (

    <div className="TimelineNode" onClick={()=>compareNode("node-compare-", id)}>

      <Handle type="target" position={Position.Left} />

      <div className="node-content">

        <div id={"node-circle-"+id} className={ data.t0 ? 'node-circle node-t0' : 'node-circle'}> {/*onClick={()=>showCard("node-card-content-"+id)}> */}
          { data.label ? <p>{(data.label)[0]}<sub>{(data.label).slice(1)}</sub></p> : '' }
        </div>

        <div className="node-description">
          <div id={"node-title-"+id} className="node-title"> {data.title} </div>
          <div id={"node-subtype-"+id} className="node-subtype"> {data.subtype} </div>

          {
            data.assays > 0 ? 

            <div>
              <div id={"node-assays-"+id} className='node-assays'> <a href={"/query/results/?planned_visits="+id.toLowerCase()}> {data.assays} assays </a> </div> 
              <button id={"node-compare-"+id} class="node-compare">compare</button>
            </div>

            : null
          }
          
        </div>
        <div id={"node-event-"+id} className="node-event-id node-description"> {data.plannedVisitId} </div>
        <div id={"time-unit-"+id} className="node-time-unit node-description"> {data.time} </div>

        {/* <div id={"node-card-content-"+id} className="node-card-content">

          {data.content ? 
          
            data.content.map(content => (
              <div>{content.description}</div>
            ))

            : ''
          }

        </div> */}


      </div>

      <Handle type="source" position={Position.Right} />

    </div>
  );
}

export default TimelineNode;

